"use client"; // This is a client component 👈🏽

import Link from "next/link";
import { useState } from "react";

/**
 * Composant d'une des liste déroulante présent dans la page d'accueuil
 * 
 * @param {object} parametter - Paramètre du composant.
 * @param {Array<string>} parametter.menu - Liste des titres des liens.
 * @param {Array<string>} parametter.links - Liste des liens.
 * @param {Array<boolean>} parametter.links - Liste de valeur booléenne indiquant si un lien doit ouvrir un nouvel onglet.
 * @param {'Young'|'Alumni'|'Researcher'|'Student'} - Profil de liste déroulante.
 * @param {string} parametter.id - id de l'élément html de la liste déroulante.
 * 
 * @returns 
 */
export default function DropdownPresentation({title,menu,typeMenu,id,links,isBlank}){
    const [svgColor] = useState(()=>{
        switch(typeMenu){
            case "Young":return "#00949D";
            case "Student":return "#B8D5Fd";
            case "Researchers":return "#EF4B38";
            case "Alumni":return "#FFD13C"
        }
    })
    return(
        <div className=" rounded-xl text-center dropdown lg:col-span-3 group" id={id}>
            <div className={` h-2 rounded-t-xl  ${typeMenu}DropdownHead`}>
            </div>
            <div className={"relative shadow-xl rounded-b-xl group-hover:rounded-none bg-white inline-block py-4 px-2 dropdown-title group flex"}>
                <div className="flex space-x-2 mx-auto items-center">
                    <h2 className="relative text-[max(0.8vw,18px)] font-bold">{title}</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18.378 10.999" className={"md:w-8 w-4 inline-block group-hover:rotate-180 transition " } >
                        <path id="Tracé_10" data-name="Tracé 10" d="M862.067,1010.5l-8.794-9.312a1,1,0,1,1,1.454-1.373l7.36,7.793,7.574-7.8a1,1,0,0,1,1.435,1.393Z" transform="translate(-853 -999.5)" fill={svgColor}/>
                    </svg>
                </div>

                
            </div>
            <ul className="shadow-xl rounded-b-xl text-center md:text-sm text-xs px-2 bg-white" id={`${id}-menu`}>
                {
                    menu.map((item,i)=> <a href={links[i]} key={i} target={isBlank[i]?"_blank":"_self"} ><li className="border-b-2 py-3 hover:cursor-pointer hover:font-bold transition ease-in-out text-xs tracking-[1.95px]">{item}</li></a> )
                }
                
                
            </ul>
        </div>
    )
    
}